<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <v-col cols="12">
          <div class="text-h6">Consulta de las actividades forestales</div>
        </v-col>
        <v-col cols="12">
          <form-meta
            :data="registro"
            :remove-commit="'removerForestal'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          />
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            * Campos requeridos
          </div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            readonly
            :value="getNombreDeFincas(registro.id_finca)"
            label="Finca*"
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            readonly
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="registro.id_parcela"
            :no-data-text="$vuetify.noDataText"
            readonly
            outlined
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Parcela"
          />
        </v-col>
        <v-col cols="6">
          <n-date
            readonly
            label="Fecha*"
            range-type="production"
            :date.sync="registro.fecha"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            readonly
            label="Ciclo*"
            outlined
          />
        </v-col>
        <!-- listado dinámico de producciones forestales -->
        <v-col cols="12">
          <v-btn depressed block class="primary--text">
            <v-icon left>mdi-plus</v-icon>
            Producción forestal
          </v-btn>
        </v-col>
        <template v-for="(produccion, index) in registro.producciones">
          <v-col :key="`${index}estatus`" cols="6" md="4">
            <v-select
              v-model="produccion.estatus"
              :items="estatus"
              label="Estatus"
              outlined
              disabled
            />
          </v-col>
          <v-col :key="`${index}rubro`" cols="6" md="4">
            <v-select
              v-model="produccion.id_rubro_forestal"
              :items="rubros_filtrados"
              readonly
              item-text="descripcion"
              item-value="id"
              label="Rubro*"
              outlined
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}produccion`" cols="6" md="4">
            <v-text-field
              v-model.number="produccion.produccion"
              readonly
              label="Producción*"
              outlined
            >
              <template v-slot:append>
                <unit-picker group="to_tuca" />
              </template>
            </v-text-field>
          </v-col>
          <v-col :key="`${index}superficie`" cols="6" md="6">
            <v-text-field
              v-model.number="produccion.superficie_ocupada"
              readonly
              label="Superficie ocupada*"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
          <v-col :key="`${index}anual`" cols="6" md="6">
            <v-text-field
              v-model.number="produccion.ingreso_anual"
              readonly
              label="Ingreso anual*"
              suffix="$"
              outlined
            >
            </v-text-field>
          </v-col>
        </template>
        <!-- Situación de desastre
        <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'FORESTAL'"
          @eliminar="eliminarDesastre(index)"
        /> -->
        <!-- listado dinámico de destinos -->
        <codestino
          :destinos="registro.destinos"
          :producciones="registro.producciones"
          :listado-destinos="destino"
          :unit-picker="{ group: 'to_tuca' }"
          :rubros="rubro_forestal"
          :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
        />
        <v-col cols="12">
          <div class="text-h6">Observaciones</div>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="registro.observacion"
            readonly
            label="Observaciones"
            auto-grow
            outlined
            rows="1"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '@/utilidades'
//import { danotrx } from '@/modelos'
import { produccion_forestal, formulario_forestal } from '@/modelos'
//import FincaSelectItem from '@/components/FincaSelectItem.vue'
//import ModalParcela from '@/components/ModalParcela.vue'
//import ModalEstablecimiento from '@/components/ModalEstablecimiento.vue'
//import SituacionDeDesastre from '@/components/form/SituacionDeDesastre.vue'

export default {
  name: 'Forestal',
  components: {
    Codestino: () => import('@/components/form/CoDestino.vue'),
    //FincaSelectItem,
    //ModalParcela,
    //ModalEstablecimiento,
    //SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      tabla_principal_id: 'id',
      tabla_produccion_id: 'id_forestal',
      tabla_produccion_id_rubro: 'id_rubro_forestal',
      ruta_registros: 'forestales',
      ruta_registro: 'forestal',
      nombre_registros_en_state: 'forestalesc',
      nombre_registro_en_state: 'forestal',
      dispatch_get_registro: 'getForestales',
      registro: clona(formulario_forestal),
      registro_produccion: clona(produccion_forestal),
    }
  },
  computed: {
    ...mapState('listados', ['rubro_forestal']),
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getNombreDeFincas',
    ]),
    rubros_filtrados() {
      const selected = this.registro.producciones.map(
        (v) => v[this.tabla_produccion_id_rubro]
      )
      return this.rubro_forestal.map((v) => ({
        ...v,
        disabled: selected.includes(v.id),
      }))
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Consulta Forestal')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
    } else {
      this.registro = clona(formulario_forestal)
    }
  },
  methods: {
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela
        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_rubro_forestal)
              .map((prod) => prod.id_rubro_forestal)
          : []
        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // required fields to be fulfilled
        if (ciclo && fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarForestales',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
  },
}
</script>
